export default "__VITE_ASSET__DaW8jMZs__"